import React from 'react';

export const AppContext = React.createContext({
    user:false, 
    setUser:()=>{},
    tycAccepted:false, 
    setTyCAccepted:()=>{},
    tycCheckbox:false,
    setTyCCheckbox:()=>{},
    logout: () => {},
});

AppContext.displayName = 'AppContext';